var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"id":"HorseDetail","no-gutters":""}},[_c('v-col',{attrs:{"cols":"8"}},[_c('HorseEvents',{attrs:{"horse":_vm.horse}})],1),_c('v-col',{attrs:{"cols":"4"}},[_c('HorseInfoDetail',{attrs:{"horse":_vm.horse}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }